import { Box, Typography } from "@mui/material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { Widget } from "@arelia-types/widget";
import { formatCurrency } from "@arelia-utils/helpers/formatCurrency";
import { ReactElement } from "react";

type Props = {
  loading: boolean;
  widgetConfig: Widget;
  data: any;
  headerComponent?: ReactElement;
};

export default function RevenuePresenter({ widgetConfig, loading, data, headerComponent }: Props) {
  return (
    <WidgetCard
      widgetId={widgetConfig.id}
      title={widgetConfig.name}
      loading={loading}
      widgetConfig={widgetConfig}
      headerComponent={headerComponent}
      disableFavorite={true}
    >
      {data && <Box sx={styles.container}>
        <Typography variant="h2">{formatCurrency(data?.revenueGross ?? 0)} Gross</Typography>
        <Typography variant="h3" color="primary">{formatCurrency(data?.revenueNet ?? 0)} Net</Typography>
        <Typography variant="h3" color="error">{formatCurrency(data?.fees ?? 0)} Fees</Typography>
      </Box>}
    </WidgetCard>
  );
}

const styles = {
  container: {
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    flex: 1
  }
}